export default function AcademyBody({ description, link }){
    return(
        <div className="academy-body">
            <p className="academy-description">{ description.split('\n').map((line, i)=> <> { i > 0 && <br/> }<span>{ line }</span> </>) }</p>
            <a href={ link } className="academy-register-link" rel="noreferrer">
                <button className="academy-register-button">Register Now</button>
            </a>
        </div>
    )
}